import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { BadgeCheck, ShieldX, Loader2, GraduationCap } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyCertificate() {
  const { code } = useParams();
  const [state, setState] = useState({ loading: true, data: null });

  useEffect(() => {
    axios.get(`${API}/certificates/verify/${code}`)
      .then((r) => setState({ loading: false, data: r.data }))
      .catch(() => setState({ loading: false, data: { valid: false } }));
  }, [code]);

  const { loading, data } = state;
  const valid = data?.valid;

  return (
    <div dir="rtl" className="flex min-h-screen items-center justify-center bg-[#FFFDF7] p-4 font-body">
      <div data-testid="verify-card" className="w-full max-w-lg rounded-3xl border border-slate-100 bg-white p-8 text-center soft-shadow">
        <Link to="/" className="mb-6 inline-flex items-center gap-2 text-navy">
          <GraduationCap className="h-6 w-6 text-greenx" />
          <span className="font-heading font-bold">منصة سُفراء</span>
        </Link>

        {loading ? (
          <div className="py-10"><Loader2 className="mx-auto h-10 w-10 animate-spin text-greenx" /><p className="mt-3 text-slate-500">جارٍ التحقق من الشهادة...</p></div>
        ) : valid ? (
          <>
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100">
              <BadgeCheck className="h-9 w-9 text-emerald-600" />
            </div>
            <h1 className="mt-4 font-heading text-2xl font-bold text-emerald-700">شهادة موثّقة وصحيحة ✓</h1>
            <p className="mt-1 text-sm text-slate-500">تم التحقق من صحة هذه الشهادة عبر المنصة</p>
            <div className="mt-6 space-y-3 rounded-2xl bg-slate-50 p-5 text-start">
              <Row label="اسم الطالب" value={data.student_name} testid="verify-student" />
              <Row label="البرنامج" value={data.program_name} testid="verify-program" />
              <Row label="التقدير" value={`${data.grade_letter} (${data.final}%)`} />
              <Row label="الساعات العلمية" value={`${data.attended_hours} / ${data.total_hours} ساعة`} />
              <Row label="رقم الشهادة" value={data.cert_number} mono />
              <Row label="تاريخ الإصدار" value={data.issued_date} />
            </div>
          </>
        ) : (
          <>
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-rose-100">
              <ShieldX className="h-9 w-9 text-rose-600" />
            </div>
            <h1 data-testid="verify-invalid" className="mt-4 font-heading text-2xl font-bold text-rose-700">شهادة غير صالحة</h1>
            <p className="mt-1 text-sm text-slate-500">لم يتم العثور على شهادة بهذا الرمز. قد يكون الرمز غير صحيح.</p>
          </>
        )}
      </div>
    </div>
  );
}

function Row({ label, value, mono, testid }) {
  return (
    <div className="flex items-center justify-between gap-3 border-b border-slate-100 pb-2 last:border-0 last:pb-0">
      <span className="text-sm text-slate-400">{label}</span>
      <span data-testid={testid} className={`text-sm font-semibold text-navy ${mono ? "font-mono" : ""}`}>{value}</span>
    </div>
  );
}
